import { z } from 'zod';
import { requiredText } from './fields';
import { idSchema } from './ids';

/** 60×60 PNG thumbnail as a data URL (FR-TECH-003); the browser crops and scales it. */
export const TECH_LOGO_SIZE = 60;
export const techLogoSchema = z
  .string()
  .max(60_000, { message: 'Attēls ir par lielu' })
  .regex(/^data:image\/png;base64,[A-Za-z0-9+/]+=*$/, { message: 'Nederīgs attēls.' });

export const technologyInputSchema = z.object({
  name: requiredText(100, 'Ievadi nosaukumu.'),
  logo: techLogoSchema.nullable().optional(),
});
export type TechnologyInput = z.input<typeof technologyInputSchema>;

/** Rename and/or change the logo (FR-TECH-004/005). */
export const technologyUpdateSchema = z.object({
  name: requiredText(100, 'Ievadi nosaukumu.').optional(),
  logo: techLogoSchema.nullable().optional(),
});

export const technologySchema = z.object({
  id: idSchema,
  name: z.string(),
  logo: z.string().nullable(),
});
export type Technology = z.infer<typeof technologySchema>;

/** Technologies of one project (FR-TECH-007/008). */
export const projectTechnologiesSchema = z.object({ technologyIds: z.array(idSchema).max(500) });

/** Copy this project's technologies to other projects (FR-TECH-010). */
export const copyTechnologiesSchema = z.object({
  projectIds: z.array(idSchema).min(1, { message: 'Izvēlies vismaz vienu projektu.' }).max(500),
});
export const copyTechnologiesResultSchema = z.object({ copied: z.number().int().min(0) });
